import React, {FunctionComponent} from "react"
import {CircleExclamationIcon} from "@App/Components/common/Icons";

export type NonBookableHintModalProps = {
    text: string
}

export const NonBookableHintModal: FunctionComponent<NonBookableHintModalProps> = (props: NonBookableHintModalProps)  => {

    return (
        <div className="flex rounded-md bg-primary-500 p-4 mb-4 partnerHint transition-all duration-1000">
            <div className="flex-shrink-0 self-center">
                <CircleExclamationIcon className="h-4 w-5 text-white fill-white" aria-hidden="true"/>
            </div>
            <div className="ml-3 pt-1">
                <p className="text-sm text-white font-bold">{props.text}</p>
            </div>
        </div>
    )
}
